import { ROUTES, SECTION_IDS } from '../../../core/constants/navigation';
import { PAGE_META } from '../../../core/constants/seo';
import { useHashScroll } from '../../../core/hooks/useHashScroll';
import { usePageMeta } from '../../../core/hooks/usePageMeta';
import { site } from '../../../global/config/site';
import Button from '../../../common/components/Button/Button';
import { IconArrowRight } from '../../../common/icons';

import '../styles/not-found.css';

const PAGE = { ...PAGE_META.NOT_FOUND, url: `${site.url}${PAGE_META.NOT_FOUND.path}` };

export default function NotFound() {
    useHashScroll();
    usePageMeta(PAGE);

    return (
        <section className="not-found layout-container" aria-labelledby="not-found-title">
            <p className="not-found__code" aria-hidden="true">404</p>
            <h1 id="not-found-title" className="not-found__title">Esta página no está al aire</h1>
            <p className="not-found__text">
                Es posible que el enlace esté roto o que la página haya cambiado de lugar.
            </p>
            <div className="not-found__actions">
                <Button to={ROUTES.HOME} icon={<IconArrowRight />}>Volver al inicio</Button>
                <Button to={{ pathname: ROUTES.HOME, hash: `#${SECTION_IDS.CONTACT}` }} variant="outline">
                    Contactar al equipo
                </Button>
            </div>
        </section>
    );
}
